export default {
	todoAll (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'export/todo/all', params)
	},
	todoRunning (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'export/todo/running', params)
	},
	todoFinished (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'export/todo/finished', params)
	},
	reservationAll (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'export/reservation/all', params)
	}
}



// WEBPACK FOOTER //
// ./src/api/CsvExport.js